'use client'

import type { MenuItem, MenuSeparator, NavGroup } from '@graftcode/design-system'

import { AppVariant } from '../../../../enums'
import { BaseMobileMenu } from '../../BaseMobileMenu'

interface GatewayMobileMenuProps {
  /** Whether the menu is open */
  isOpen: boolean
  /** Callback to close the menu */
  onClose: () => void
  /** Navigation groups */
  menuGroups: NavGroup[]
  /** Items for the Help dropdown / drawer */
  helpItems?: (MenuItem | MenuSeparator)[]
  /** Handler for profile click */
  onProfileClick?: (itemId: string) => void
  /** Handler for help item click */
  onHelpClick?: (itemId: string) => void
  /** Handler for navigation click */
  onNavigationClick?: (url: string) => void
  /** Handler for project selection */
  onProjectClick?: (projectId: string) => void
  /** Handler for workspace selection */
  onWorkspaceClick?: (workspaceId: string) => void
  /** Handler to open workspace settings */
  onOpenWorkspaceSettings?: () => void
  /** Handler to open project settings */
  onOpenProjectSettings?: () => void
  /** Handler to open project members */
  onOpenProjectMembers?: () => void
  /** Handler to trigger project invite flow */
  onInviteProjectClick?: () => void
  /** Handler to trigger workspace invite flow */
  onInviteWorkspaceClick?: () => void
  /** Handler to open create project flow */
  onCreateProject?: () => void
  notificationBadge?: number
  onNotificationClick?: () => void
}

export function GatewayMobileMenu({
  isOpen,
  onClose,
  menuGroups,
  helpItems,
  onProfileClick,
  onHelpClick,
  onNavigationClick,
  onProjectClick,
  onWorkspaceClick,
  onOpenWorkspaceSettings,
  onOpenProjectSettings,
  onOpenProjectMembers,
  onInviteProjectClick,
  onInviteWorkspaceClick,
  onCreateProject,
  notificationBadge,
  onNotificationClick,
}: GatewayMobileMenuProps) {
  return (
    <BaseMobileMenu
      isOpen={isOpen}
      onClose={onClose}
      appVariant={AppVariant.GATEWAY}
      menuGroups={menuGroups}
      helpItems={helpItems}
      onProfileClick={onProfileClick}
      onHelpClick={onHelpClick}
      onNavigationClick={onNavigationClick}
      onProjectClick={onProjectClick}
      onWorkspaceClick={onWorkspaceClick}
      onOpenWorkspaceSettings={onOpenWorkspaceSettings}
      onOpenProjectSettings={onOpenProjectSettings}
      onOpenProjectMembers={onOpenProjectMembers}
      onInviteProjectClick={onInviteProjectClick}
      onInviteWorkspaceClick={onInviteWorkspaceClick}
      onCreateProject={onCreateProject}
      notificationBadge={notificationBadge}
      onNotificationClick={onNotificationClick}
    />
  )
}
